import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(['zoom:' + (_ctx.Client ? '20%' : '') + ';', {
      "min-width": "1560px"
    }])
  }, null, 4);
}